export enum CenterProjection {
    dataTable = 'dataTable',
    select = 'select',
    form = 'form',
    report = 'report',
    survey = 'survey',
}
